var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterThanEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04152 11.2464L12.2915 7.49635L6.04152 3.74635C5.95945 3.69711 5.88895 3.63379 5.83406 3.56003C5.77917 3.48626 5.74096 3.40349 5.72162 3.31644C5.70227 3.22938 5.70217 3.13975 5.72131 3.05266C5.74045 2.96557 5.77847 2.88272 5.83319 2.80885C5.94369 2.65967 6.11552 2.5561 6.31087 2.52094C6.4076 2.50353 6.50719 2.50344 6.60396 2.52066C6.70073 2.53789 6.79278 2.57211 6.87485 2.62135L13.9599 6.87235C14.074 6.94085 14.1676 7.03364 14.2323 7.14249C14.297 7.25134 14.3309 7.37289 14.3309 7.49635C14.3309 7.61981 14.297 7.74136 14.2323 7.85022C14.1676 7.95907 14.074 8.05186 13.9599 8.12035L6.87485 12.3714C6.79278 12.4206 6.70073 12.4548 6.60396 12.472C6.50719 12.4893 6.4076 12.4892 6.31087 12.4718C6.21415 12.4544 6.12218 12.42 6.04021 12.3706C5.95825 12.3212 5.88791 12.2577 5.83319 12.1839C5.77847 12.11 5.74045 12.0271 5.72131 11.94C5.70217 11.853 5.70227 11.7633 5.72162 11.6763C5.74096 11.5892 5.77917 11.5064 5.83406 11.4327C5.88895 11.3589 5.95945 11.2956 6.04152 11.2464Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.75H5.83333C5.61232 15.75 5.40036 15.671 5.24408 15.5303C5.0878 15.3897 5 15.1989 5 15C5 14.8011 5.0878 14.6103 5.24408 14.4697C5.40036 14.329 5.61232 14.25 5.83333 14.25H14.1667C14.3877 14.25 14.5996 14.329 14.7559 14.4697C14.9122 14.6103 15 14.8011 15 15C15 15.1989 14.9122 15.3897 14.7559 15.5303C14.5996 15.671 14.3877 15.75 14.1667 15.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanEqual);
export default __webpack_public_path__ + "static/media/greater-than-equal.92ddb25ba20b538ce8aae00c8b37dbf0.svg";
export { ForwardRef as ReactComponent };